import { RiFlightLandFill, RiInboxArchiveLine, RiPriceTag2Line, RiSafeLine, RiVerifiedBadgeFill } from "react-icons/ri";
import { Link } from "react-router-dom";

const SIZE = 20;

export default [
    {
        key: "/import",
        icon: <RiFlightLandFill size={SIZE} />,
        level: 0x1fff,
        label: "Import",
        children: [
            {
                key: "/import/awb",
                icon: <RiInboxArchiveLine size={SIZE} />,
                level: 0x1fff,
                label: <Link to={"/import/awb"}>AWB Import</Link>,
            },
            {
                key: "/import/import_in",
                icon: <RiSafeLine size={SIZE} />,
                level: 0x1fff,
                label: <Link to={"/import/import_in"}>Import Gate In</Link>,
            },
            {
                key: "/import/import_verify",
                icon: <RiVerifiedBadgeFill size={SIZE} />,
                level: 0x1fff,
                label: <Link to={"/import/import_verify"}>Import Verify</Link>,
            },
            {
                key: "/import/import_report",
                icon: <RiPriceTag2Line size={SIZE} />,
                level: 0x1ff2,
                label: <Link to={"/import/import_report"}>Import Report</Link>,
            }
        ],
    },
];
